<template>
  <div 
  class="max-w-custom py-4 relative flex flex-col w-full mx-auto">
    <RoutePath v-if="$userStore.user && routepath" />
    <div class="w-full flex flex-col gap-4 py-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import RoutePath from "@/views/RoutePath.vue";
export default {
  name: "PageElement",
  components: {
    RoutePath,
  },
  props: {
    routepath: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isIframe() {
      return this.$route.meta?.page.iframe == "true";
    },
  }
};
</script>